import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const ProjectOverview = () => {
  const navigate = useNavigate();

  const backgroundImageUrl =
    'https://static.vecteezy.com/system/resources/previews/001/235/998/non_2x/solar-panel-cell-on-dramatic-sunset-sky-background-free-photo.jpg';

  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat relative pt-[70px]"
      style={{ backgroundImage: `url(${backgroundImageUrl})` }}
    >
      {/* Internal CSS for hexagon shape */}
      <style>{`
        .hexagon {
          width: 150px;
          height: 130px;
          clip-path: polygon(
            50% 0%,
            93% 25%,
            93% 75%,
            50% 100%,
            7% 75%,
            7% 25%
          );
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
        }

        .hex-grid {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          gap: 20px;
          margin-top: 1rem;
        }

        .hexagon img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      `}</style>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60 z-0"></div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-8 py-8 rounded-xl text-white bg-[#00000042]">
        {/* Header */}
        <div className="flex items-center gap-4 mb-6">
          <span
            className="cursor-pointer text-[#b9dd7a] text-xl hover:text-[#a6cb67]"
            onClick={() => navigate(-1)}
            title="Go back"
          >
            <FaArrowLeft />
          </span>
          <h2 className="text-4xl font-bold text-white">Project Overview</h2>
        </div>

        {/* Summary Text */}
        <div className="text-sm max-w-6xl mb-6">
          <h3 className="text-lg text-[#f6a622] font-semibold mb-2">Project Execution Summary</h3>
          <p className='font-semibold'>
            Struja Green Energy Private Limited is at the forefront of the renewable energy sector,
            dedicated to providing innovative and sustainable energy solutions. Our latest venture,
            the 100 MW Solar Ground Mounted Project epitomizes cutting-edge solar technology and engineering excellence.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Left Column */}
          <div>
            <div className="mb-6">
              <h4 className="text-[#b9dd7a] font-semibold text-md mb-2">Project Under Execution</h4>
              <ul className="list-disc list-inside text-sm space-y-1">
                <li className='font-semibold'>Thiruvarur District 15 MW</li>
                <li className='font-semibold'>Pudukkottai District 20 MW</li>
                <li className='font-semibold'>Thiruvallur District 50 MW</li>
                <li className='font-semibold'>Thiruvannamalai District 15 MW</li>
              </ul>
            </div>

            <div>
              <h4 className="text-[#f6a622] font-semibold text-md mb-2">Project Pipeline - Our Future Projects</h4>
              <ul className="list-disc list-inside text-sm space-y-1">
                <li className='font-semibold'>Karur District 50 MW</li>
                <li className='font-semibold'>Viluppuram District 100 MW</li>
                <li className='font-semibold'>Pudukkottai District 15 MW</li>
                <li className='font-semibold'>Thiruvannamalai District 15 MW</li>
              </ul>
            </div>
          </div>

          {/* Right Column - Hexagon Images */}
          <div className="hex-grid">
            {[
              "https://images.peopleimages.com/picture/202303/2659236-solar-energy-business-people-or-engineering-team-with-blueprint-on-roof-building-grid-technology-for-innovation.-collaboration-top-or-employees-talking-or-planning-a-development-project-strategy-box_175_175.jpg",
              "https://5.imimg.com/data5/SELLER/Default/2023/8/333738214/XG/PE/PH/59022361/solar-power-consultancy-services-500x500.jpg",
              "https://images.unsplash.com/photo-1573497491208-6b1acb260507",
              "https://static.vecteezy.com/system/resources/thumbnails/039/354/331/small/two-people-having-a-shaking-hands-against-solar-panel-after-the-conclusion-of-the-agreement-in-the-renewable-energy-photo.jpg",
              "https://static.vecteezy.com/system/resources/thumbnails/048/419/348/small_2x/two-people-having-a-shaking-hands-against-solar-panel-after-the-conclusion-of-the-agreement-in-the-renewable-energy-video.jpg"
            ].map((src, idx) => (
              <div key={idx} className="hexagon">
                <img src={src} alt={`Project-${idx}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectOverview;
